import { render, staticRenderFns } from "./GridAdministracion.vue?vue&type=template&id=4985be2e&"
import script from "./GridAdministracion.vue?vue&type=script&lang=js&"
export * from "./GridAdministracion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports